import { Container } from '@/components/layout/Container';
import { Section } from '@/components/layout/Section';
import { ProductGrid } from '@/components/product/ProductGrid/ProductGrid';
import { useProductStore } from '@/store/productStore';
import { motion } from 'framer-motion';

export const Shop = () => {
  const products = useProductStore((state) => state.products);

  return (
    <div className="min-h-screen">
      <Section>
        <Container>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <div className="mb-8">
              <h1 className="text-5xl font-bold text-gray-900 mb-4">
                Shop All Products
              </h1>
              <p className="text-xl text-gray-600">
                Explore our complete collection of gaming controllers and accessories
              </p>
            </div>

            <ProductGrid products={products} />
          </motion.div>
        </Container>
      </Section>
    </div>
  );
};
